import React from "react";
import { ConnectedProps, connect } from "react-redux";
import { ReducerState } from "../../types";
import TrapTable from "../../components/Traps/index";
import { Modal } from "antd";
import WifiConnection from "../../components/DevicePanel/Wifi";
import { useAppSelector, useAppDispatch } from "../../hooks/reduxHook";
import { setWifiModalOpen } from "../../reducers/devicesSlice";

const mapStateToProps = (state: ReducerState) => {
  return {
    selected: state.devices?.selected?.uuid || null,
  };
};

const connector = connect(mapStateToProps, {});

type Props = ConnectedProps<typeof connector> & {
  // Extra props go here
};

const Traps: React.FC<Props> = () => {
  const isModalOpen = useAppSelector((state) => state.devices.isWifiModalOpen);
  const dispatch = useAppDispatch();
  return (
    <div className="px-6 h-full w-full">
      <div className="text-[40px] my-6">Traps</div>
      <TrapTable />
      <Modal
        open={isModalOpen}
        onCancel={() => {
          dispatch(setWifiModalOpen(false));
        }}
        onOk={() => {
          dispatch(setWifiModalOpen(false));
        }}
        styles={{
          content: {
            width: "600px",
            height: "400px",
            borderRadius: ".5rem",
            border: "1px solid #0C4A6E",
          },
        }}
      >
        <WifiConnection />
      </Modal>
    </div>
  );
};

export default connector(Traps);
